// Cells whose first character is one of these are interpreted as formulas
// by Excel / Google Sheets / LibreOffice. Prepending a single apostrophe
// neutralizes them without modifying display elsewhere.
const FORMULA_PREFIX_CHARS = ["=", "+", "-", "@", "\t", "\r"];

export const escapeCsvCell = (value) => {
  if (value == null) return value;
  if (typeof value !== "string") return value;
  if (value.length === 0) return value;
  return FORMULA_PREFIX_CHARS.includes(value[0]) ? `'${value}` : value;
};

// Inverse of escapeCsvCell for round-tripping downloaded files: the guard
// apostrophe is stripped only when the character after it is one that
// escapeCsvCell guards, so values with a genuine leading apostrophe survive.
export const unescapeCsvCell = (value) => {
  if (typeof value !== "string") return value;
  if (value[0] !== "'") return value;
  return FORMULA_PREFIX_CHARS.includes(value[1]) ? value.slice(1) : value;
};

export const escapeCsvQuotes = (value) =>
  typeof value === "string" ? value.replaceAll("\"", "\"\"") : value;

const isPlainObject = (value) =>
  value !== null && typeof value === "object" && [Object.prototype, null].includes(Object.getPrototypeOf(value));

// react-csv stringifies cells with `${value}` and wraps them in quotes as-is,
// so lists and objects must become strings before quote escaping, or their
// embedded quotes end the cell early and spill values into the next column.
const toCsvText = (value) => {
  if (Array.isArray(value)) return value.map(toCsvText).join(",");
  if (isPlainObject(value)) return JSON.stringify(value);
  return value;
};

export const sanitizeCsvRows = (rows) =>
  rows.map((row) => {
    const out = {};
    for (const key of Object.keys(row)) out[key] = escapeCsvQuotes(escapeCsvCell(toCsvText(row[key])));
    return out;
  });

// Headers double as react-csv lookup keys, so only the label is escaped;
// plain string headers become { key, label } to keep their lookup intact.
export const sanitizeCsvHeaders = (headers) =>
  headers.map((header) => {
    const { key, label } = header && typeof header === "object" ? header : { key: header, label: header };
    return { ...header, key, label: escapeCsvQuotes(escapeCsvCell(label)) };
  });
